import useSWR, { Fetcher, useSWRConfig } from 'swr';

import { CompanyStatus } from '../../constants';
import { CompanyListResponse } from '../../interfaces/responses';
import { sanitize } from '../../sanitizeString';

const getKey = (query: string, includedStatuses: CompanyStatus[]) => {
  if (!query) return;
  if (query.length < 3) return;
  const params = new URLSearchParams({
    limit: '10',
    where: JSON.stringify({
      name: { ilike: `%${sanitize(query)}%` },
      ...(includedStatuses.length > 0
        ? { status: { in: includedStatuses } }
        : {}),
    }),
  }).toString();
  return `/companies?${params}`;
};

export const useCompanySearch = (
  query: string,
  includedStatuses: CompanyStatus[],
  {
    onSuccess,
    skip = false,
  }: {
    onSuccess?: (data: CompanyListResponse) => void;
    skip?: boolean;
  } = {}
) => {
  const key = skip ? null : getKey(query, includedStatuses);
  const { fetcher } = useSWRConfig();
  const { data, error, isValidating } = useSWR<CompanyListResponse>(
    key,
    fetcher as Fetcher<CompanyListResponse>,
    {
      onSuccess,
    }
  );
  const companies = data && data.data;
  const isLoading = key && !data && !error;
  return { companies, data, error, isValidating, isLoading };
};
